import { ClbLoading } from "@celebration/react/ClbLoading/ClbLoading";
import type { LoadingProps } from "@components/contracts/Loading.types";
import type React from "react";

export const CelebrationLoading: React.FC<LoadingProps> = (props) => (
  <ClbLoading {...props} />
);
